// src/components/dashboard/cases/newCase/case_id/caseTable/components/DrawHint.js
import React from "react";

const DrawHint = () => (
  <div
    style={{
      position: "absolute",
      top: 12,
      left: "50%",
      transform: "translateX(-50%)",
      zIndex: 40,
      padding: "8px 14px",
      borderRadius: 10,
      background: "rgba(8, 20, 38, 0.9)",
      border: "1px solid rgba(255, 80, 80, 0.7)",
      boxShadow: "0 6px 22px rgba(0, 0, 0, 0.5)",
      backdropFilter: "blur(12px)",
      WebkitBackdropFilter: "blur(12px)",
      color: "#ffffff",
      fontFamily: '"Segoe UI", system-ui, sans-serif',
      fontSize: 12,
      fontWeight: 600,
      letterSpacing: "0.02em",
      whiteSpace: "nowrap",
      pointerEvents: "none",
      display: "flex",
      alignItems: "center",
      gap: 8,
    }}
  >
    <span
      style={{
        display: "inline-block",
        width: 8,
        height: 8,
        borderRadius: "50%",
        background: "#ff2222",
        boxShadow: "0 0 8px rgba(255, 34, 34, 0.9)",
      }}
    />
    Drag a line anywhere — start and end can be outside the model
  </div>
);

export default DrawHint;